var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.69793 1.03446L17.9999 9.00046L1.69793 16.9665C1.60488 17.0022 1.5033 17.0095 1.40608 16.9875C1.30887 16.9654 1.22041 16.9149 1.15193 16.8425C1.08144 16.7681 1.03292 16.6757 1.01174 16.5754C0.990562 16.4751 0.997549 16.371 1.03193 16.2745L3.49993 9.00046L1.03193 1.72646C0.997549 1.62993 0.990562 1.52577 1.01174 1.42552C1.03292 1.32526 1.08144 1.23283 1.15193 1.15846C1.22041 1.08601 1.30887 1.03555 1.40608 1.01347C1.5033 0.991389 1.60488 0.998696 1.69793 1.03446Z",
    stroke: "#873CAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9H18",
    stroke: "#873CAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2);
export default __webpack_public_path__ + "static/media/send_2.7a3ee234d1547d877f077606773756a2.svg";
export { ForwardRef as ReactComponent };